import axios from 'axios';

import { InvestorOnboardingSignUpDto, InvestorOnboardingSignUpInfoDto } from '../dtos/investor-onboarding-sign-up.dto';

class InvestorOnboardingService {
  async getSignUpInfo(): Promise<InvestorOnboardingSignUpInfoDto> {
    return (await axios.get<InvestorOnboardingSignUpInfoDto>('/investor-onboarding/sign-up-info')).data;
  }

  /** Partial and safe to repeat: called once per wizard step */
  async saveSignUpInfo(payload: InvestorOnboardingSignUpDto): Promise<void> {
    await axios.patch('/investor-onboarding/sign-up-info', payload);
  }

  async completeInitialOnboarding(): Promise<void> {
    await axios.post('/investor-onboarding/complete/initial');
  }

  async completePropertyOnboarding(): Promise<void> {
    await axios.post('/investor-onboarding/complete/property');
  }

  async completeDashboardOnboarding(): Promise<void> {
    await axios.post('/investor-onboarding/complete/dashboard');
  }

  async completeRenterProfileOnboarding(): Promise<void> {
    await axios.post('/investor-onboarding/complete/renter-profile');
  }
}

export default new InvestorOnboardingService();
